// extracted by mini-css-extract-plugin
export default {"root":"PHEWTlIQIiALSndVsGFV","wrap":"cSew_907MesZauXemucc","icon":"OjyqEbKVCfvH2seCYcUN","text":"YrI0XIa0b397XhaHrgBq"};